"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Storage_1 = require("./Storage");
var DOM_1 = require("./DOM");
var UI = /** @class */ (function () {
    function UI() {
    }
    UI.init = function () {
        if (localStorage.getItem("boards") !== null &&
            localStorage.getItem("boards") !== "[]") {
            // reconstruct board links (in sidebar) from local storage
            Storage_1.default.boards.forEach(function (board, boardIndex) {
                DOM_1.default.createBoardBtn(boardIndex);
            });
            DOM_1.default.constructBoard(UI.currentBoardIndex);
        }
        var newBoardBtn = document.querySelector("button.newBoard");
        var newBoardInput = document.querySelector("input.newBoard");
        DOM_1.default.attachInputListener(newBoardBtn, newBoardInput, function () {
            var userInput = newBoardInput.value;
            var boardIndex = Storage_1.default.createBoard(userInput);
            DOM_1.default.createBoardBtn(boardIndex);
            UI.currentBoardIndex = boardIndex;
            Storage_1.default.setLocalStorage(); // to save the new current board index
            console.log(Storage_1.default.boards);
        });
    };
    return UI;
}());
exports.default = UI;
